export default __webpack_public_path__ + "static/media/rfid-pos.33bf87dd.jpg";